// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"243":"2dfa2903f1481059ef58","728":"ed2013af1c8139c79398"}[chunkId] + ".js";
};